import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BlockModalDragModule } from 'app/shared/directives/block-modal-drag/block-modal-drag.module';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { ButtonModule } from '../../../button/button.module';
import { CheckBoxModule } from '../../../check-box/check-box.module';
import { IconicModule } from '../../../iconic/iconic.module';
import { InputBoxModule } from '../../../input-box/input-box.module';
import { ListModule } from '../../../list/list.module';
import { RadioGroupModule } from '../../../radio-group/radio-group.module';
import { ScrollViewModule } from '../../../scroll-view/scroll-view.module';
import { SelectBoxModule } from '../../../select-box/select-box.module';
import { TypeUtilizationBoxModule } from '../type-utilization-box/type-utilization-box.module';
import { RegisterElementMapComponent } from './register-element-map.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ScrollViewModule,
    ListModule,
    RadioGroupModule,
    ButtonModule,
    IconicModule,
    SelectBoxModule,
    InputBoxModule,
    CheckBoxModule,
    TypeUtilizationBoxModule,
    PipesModule,
    BlockModalDragModule,
  ],
  declarations: [RegisterElementMapComponent],
  exports: [RegisterElementMapComponent],
})
export class RegisterElementMapModule {}
